function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { AddonLoader } from '../../addon-loader';
import { PerfKey } from '../../../../utils/perf';
import { sdkLogger } from '../../../../logger';
import { CoreVideoInternal } from '../../../../core-video-internal';
import { DeferredReportingSession } from '../../../reporting/deferred-reporting-session';
import { checkIfDisabledForAutoPlayTrailer } from '../reporting-addon-loader';
export var AdobeEdgeReportingAddonLoader = /*#__PURE__*/ function(AddonLoader) {
    "use strict";
    _inherits(AdobeEdgeReportingAddonLoader, AddonLoader);
    function AdobeEdgeReportingAddonLoader(device, metaAdapterFactory) {
        _class_call_check(this, AdobeEdgeReportingAddonLoader);
        var _this;
        _this = _call_super(this, AdobeEdgeReportingAddonLoader, [
            device
        ]), _define_property(_this, "device", void 0), _define_property(_this, "metaAdapterFactory", void 0), _define_property(_this, "perfKey", void 0), _define_property(_this, "metaAdapter", void 0), _define_property(_this, "create", void 0), _this.device = device, _this.metaAdapterFactory = metaAdapterFactory, _this.perfKey = PerfKey.adobeEdge, _this.create = function(reportingAddonSessionData) {
            var _reportingSessionConfig_adobeEdge;
            var isDisabledForAutoplayTrailer = checkIfDisabledForAutoPlayTrailer(reportingAddonSessionData, 'adobe');
            var common = reportingAddonSessionData.common, reportingSessionConfig = reportingAddonSessionData.reportingSessionConfig, session = reportingAddonSessionData.session, sessionItem = reportingAddonSessionData.sessionItem, eventQueue = reportingAddonSessionData.eventQueue;
            if (!(reportingSessionConfig === null || reportingSessionConfig === void 0 ? void 0 : (_reportingSessionConfig_adobeEdge = reportingSessionConfig.adobeEdge) === null || _reportingSessionConfig_adobeEdge === void 0 ? void 0 : _reportingSessionConfig_adobeEdge.enabled) || isDisabledForAutoplayTrailer || !common || !reportingSessionConfig.adobeEdge) {
                return;
            }
            if (!_this.metaAdapter) {
                sdkLogger.withContext('Adobe Edge Addon Loader').error('Tried to load Adobe Edge Addon with no meta adapter.');
                return;
            }
            var excludedPlaybackTypes = _this.metaAdapter.getExcludedPlaybackTypes();
            if (excludedPlaybackTypes.includes(sessionItem.type)) {
                return;
            }
            var reportingSession = CoreVideoInternal.capabilities.hasLowerEndSpecs() ? new DeferredReportingSession(session, eventQueue) : session;
            var postDestroy = CoreVideoInternal.capabilities.hasLowerEndSpecs() ? function() {
                return reportingSession.destroy();
            } : undefined;
            var config = _object_spread_props(_object_spread({}, reportingSessionConfig.adobeEdge.config), {
                appName: common.appName,
                appVersion: common.appVersion,
                playerVersion: session.playerVersion
            });
            var adobeEdgeAddon = _this.construct(config, reportingSession, _this.metaAdapter, sessionItem, postDestroy);
            return adobeEdgeAddon;
        };
        return _this;
    }
    _create_class(AdobeEdgeReportingAddonLoader, [
        {
            key: "moduleLoader",
            value: function moduleLoader() {
                var _this = this;
                return _async_to_generator(function() {
                    var AdobeEdgeAddon;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.metaAdapterFactory()
                                ];
                            case 1:
                                _this.metaAdapter = _state.sent();
                                if (!_this.metaAdapter) {
                                    sdkLogger.withContext('Adobe Edge Reporting Addon Loader').error('Tried to load Adobe Edge Addon with no meta adapter.');
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    import(/* webpackChunkName: "sdk-ad-adbe" */ '../../../reporting/adobe-edge-addon/adobe-edge-addon')
                                ];
                            case 2:
                                AdobeEdgeAddon = _state.sent().AdobeEdgeAddon;
                                return [
                                    2,
                                    AdobeEdgeAddon
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkIsModuleRequired",
            value: function checkIsModuleRequired(internalConfigPerPlaybackType) {
                var isEnabled = this.checkInternalConfigLeaves(internalConfigPerPlaybackType, 'addons.reporting.adobeEdge.enabled', true);
                return isEnabled;
            }
        }
    ]);
    return AdobeEdgeReportingAddonLoader;
}(AddonLoader);

//# sourceMappingURL=adobe-edge-reporting-addon-loader.js.map